import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { observer } from "mobx-react";
import backgroundJobNoticesStore from "../../stores/background-job-notice-store";
import BackgroundJobNotice from "./background-job-notice";
import "./background-job-notices.scss";

const BackgroundJobNotices: React.FC = observer(() => {
    const el = useRef(document.createElement("div"));
    const parentElement = document.body;
    const notice = backgroundJobNoticesStore.notice;

    useEffect(() => {
        parentElement.appendChild(el.current);
        const elem = el.current;
        return () => {
            elem?.parentNode?.removeChild(elem);
        };
    }, [parentElement]);

    if (!notice) {
        return null;
    }

    return createPortal(
        (
            <div className="background-job-notices">
                <BackgroundJobNotice notice={notice} />
            </div>
        ),
        el.current,
    );
});

export default BackgroundJobNotices;
